import { useMemo } from 'react'

import { RightOutlined } from '@ant-design/icons'
import { Breadcrumb } from 'antd'
import { createStyles } from 'antd-style'

import { useHomeStore } from '../../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  breadcrumb: {
    paddingBlock: token.paddingSM,
    backgroundColor: token.colorWhite,
    borderBlockEnd: `1px solid ${token.colorBorder}`
  },
  separator: {
    display: 'inline-block',
    paddingInline: 4,
    paddingBlock: 4,
    fontSize: token.fontSizeSM,
    color: token.colorTextTertiary,
    backgroundColor: token.colorBgLayout
  }
}))

export const DocBreadcrumb = () => {
  const currentCatalogues = useHomeStore(state => state.currentCatalogues)
  const items = useMemo(() => {
    return currentCatalogues.map(item => ({ title: item.name }))
  }, [currentCatalogues])

  const { styles } = useStyles()

  return (
    <Breadcrumb
      className={styles.breadcrumb}
      items={items}
      separator={<RightOutlined className={styles.separator} />}
    />
  )
}
